import script from "./HistotyRrecord.vue?vue&type=script&setup=true&lang=js"
export * from "./HistotyRrecord.vue?vue&type=script&setup=true&lang=js"

import "./HistotyRrecord.vue?vue&type=style&index=0&id=67d66351&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d66351"]])

export default __exports__